module.exports = __webpack_public_path__ + "static/img/carbonzixun.7375bec5.png";